import styled from 'styled-components'
import { ReactNode } from 'react'

import FlexRow from '@/ui/FlexRow'
import Form from '@/ui/Form'
import { RadioButtonOption } from '@/types'
import ErrorLabel from './ErrorLabel'

interface FieldRadioProps {
  input: any
  label?: ReactNode
  options?: RadioButtonOption[]
  touched?: boolean
  error?: string
  submitId?: boolean
  onChange?: (value?: string | null) => void
}

const StyledCheckbox = styled(Form.Checkbox)`
  label {
    margin-bottom: 10px;
    line-height: 1;
    padding-top: 2px;
    padding-left: 25px !important;
    color: #012d3e !important;
    font-weight: 300;

    &:before,
    &:after {
      top: calc(50% - 7.5px) !important;
    }
    &:before {
      background: #fff !important;
    }
    &:after {
      background-color: ${props => props.theme.primaryColor} !important;
      transform: scale(0.6) !important;
    }
  }

  &&&&& {
    margin-bottom: 0 !important;

    input {
      &:focus {
        + label {
          :before {
            border-color: ${props => props.theme.primaryColor};
          }
        }
      }
    }
  }
`

const FieldRadio = ({
  label,
  options,
  touched,
  error,
  input,
  submitId,
  onChange,
}: FieldRadioProps) => {
  const handleChange = (value?: string | null, id?: string | null) => {
    input.onChange(submitId ? id : value)
    if (onChange) {
      onChange(submitId ? id : value)
    }
  }

  return (
    <Form.Field>
      {label}
      <FlexRow noMargin flexDirection="column">
        {options?.map(({ id, value, extra }) => (
          <StyledCheckbox
            radio
            key={id}
            label={
              extra ? (
                <label>
                  <FlexRow
                    noMargin
                    justifyContent="flex-start"
                    style={{
                      whiteSpace: 'nowrap',
                    }}>
                    {value}
                    {extra}
                  </FlexRow>
                </label>
              ) : (
                value
              )
            }
            checked={submitId ? id === input.value : value === input.value}
            onChange={() => handleChange(value, id)}
          />
        ))}
      </FlexRow>

      {touched && error && error.length && <ErrorLabel error={error} />}
    </Form.Field>
  )
}

export default FieldRadio
